import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { addSchuelerDummy } from "../../actions/schueler";
import Spinner from "../../components/Spinner";
import Calculations from "../../helpers/calculations";
import { handleSaveProject } from "../../helpers/saveProject";
import FormValidation from "../Validation/FormValidation";
import SchuelerFormFields from "./SchuelerFormFields";
import SchuelerSchema from "./SchuelerSchema";

const SchuelerNew = ({ setView }) => {
  const [showFieldErrors, setShowFieldErrors] = useState(false);
  const [variables, setVariables] = useState({});
  const [fieldSettings, setFieldSettings] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [serverError, setServerError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const currentUser = useSelector((st) => st.currentUser);
  const currentKlausur = useSelector((st) => st.currentKlausur);
  const schueler = useSelector((st) => st.schueler);
  const companies = useSelector((st) => st.companies);
  const dispatch = useDispatch();
  console.log({ schueler });

  useEffect(() => {
    const fetch = async () => {
      const _schema = new SchuelerSchema(currentKlausur);
      const _fields = _schema.getFields(companies, currentKlausur);
      // const fields = _schema.fields;
      // console.log(Object.keys(_fields))
      setFieldSettings({ ..._fields });
      const vars = {};
      Object.keys(_fields).forEach(
        (k) => (vars[k] = _fields[k].initialValue || "")
      );
      setVariables({ ...vars });
      (() => setIsLoading(false))();
    };
    if (isLoading) fetch();
  });

  if (isLoading) return <Spinner />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const calculations = new Calculations(variables, currentKlausur);
    const land = companies.find(
      (c) => c.id === parseInt(currentKlausur.companyId)
    )?.land;
    const gesamtnote = calculations.results[land]?.gesamtnote;
    // dateFormats();
    const formValidation = new FormValidation({
      fieldSettings,
      variables,
      setFieldErrors,
    });
    console.log({ formValidation });
    if (!formValidation.valid) {
      setShowFieldErrors(true);
      setTimeout(() => setShowFieldErrors(false), 3000);
      return;
    }
    const data = {
      ...variables,
      id: uuidv4(),
      klausurId: currentKlausur.id,
      createdAt: new Date().toISOString(),
      createdBy: currentUser.username,
      gesamtnote,
      entwurf: false,
    };

    dispatch(addSchuelerDummy(data));
    handleSaveProject(currentKlausur, companies, [...schueler, data]);
    setView("buttons");
  };
  const handleSaveEntwurf = async (e) => {
    e.preventDefault();
    const data = {
      ...variables,
      id: uuidv4(),
      klausurId: currentKlausur.id,
      createdAt: new Date().toISOString(),
      createdBy: currentUser.username,
      entwurf: true,
    };
    dispatch(addSchuelerDummy(data));
    handleSaveProject(currentKlausur, companies, [...schueler, data]);
    setView("buttons");
  };

  const props = {
    fieldSettings,
    variables,
    setVariables,
    fieldErrors,
    setFieldErrors,
    serverError,
    setServerError,
    handleSubmit,
    handleSaveEntwurf,
    setView,
    showFieldErrors,
  };

  return <SchuelerFormFields props={props} />;
};
export default SchuelerNew;
